import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
`;

export const ContainerForm = styled.form`
	display: flex;
	align-items: center;
	flex-direction: column;
	width: 100%;
	padding: 0 2.6rem;

	@media (max-width: 426px) {
		padding: 0 1.6rem;
	}
`;
